import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

type MovieCardProps = {
  movie: Movie;
  showSummary?: boolean;
};

export default function MovieCard({ movie, showSummary = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-0 w-full overflow-hidden bg-background-200 pb-[150%]">
        <img
          src={movie.cover}
          alt={`${movie.title}影片封面`}
          title={`${movie.title} - 日韩伦理片`}
          className="absolute left-0 top-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-950/80 px-2 py-1 text-[11px] font-medium text-background-50 backdrop-blur">
          {movie.year}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-background-50/90 px-2 py-1 text-[11px] font-semibold text-primary-700 backdrop-blur">
          <i className="ri-star-fill text-accent-500" />
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
          {movie.title}
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-1.5 text-[11px] text-foreground-500">
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-medium text-secondary-800">
            {movie.region}
          </span>
          {movie.genres.map((g) => (
            <span key={g} className="rounded-full bg-background-100 px-2 py-0.5">
              {g}
            </span>
          ))}
        </div>
        {showSummary && (
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
            {movie.summary}
          </p>
        )}
      </div>
    </Link>
  );
}